import { GelatoRelay } from "@gelatonetwork/relay-sdk";

export const gelatoRelay = new GelatoRelay();
